import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {classNames} from '../../Support/classNames';
import {Button} from 'react-bootstrap';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {PostProcessingPresenter} from './PostProcessingPresenter';
import {ReportData} from './Trend/TrendReportPresenter';

interface OwnProps {
    reportData: ReportData;
    className?: string;
}

const PostProcessingComponent: FunctionComponent<OwnProps & PresenterProps<PostProcessingPresenter>> = observer(
    ({className, presenter}) => {
        if (presenter.isPostProcessing) {
            return (
                <div className={classNames('card', className)}>
                    <div className="card-title">
                        <h5 className="d-flex justify-content-between align-items-baseline flex-row flex-wrap">
                            <span>Post processing</span>
                        </h5>
                    </div>
                    <div className="card-body">
                        There are snippets that are being processed. The report is not final until all snippets have
                        been processed. This can take a few minutes, please refresh the page or come back later.
                    </div>
                </div>
            );
        }

        if (presenter.shouldPostProcess) {
            return (
                <div className={classNames('card', className)}>
                    <div className="card-title">
                        <h5 className="d-flex justify-content-between align-items-baseline flex-row flex-wrap">
                            <span>Post processing</span>
                        </h5>
                    </div>
                    <div className="card-body">
                        Some snippets are missing the latest statistics. You can trigger post processing to get the
                        latest data.
                        <div className="d-flex flex-row justify-content-end mt-3">
                            <Button className="btn btn-primary" onClick={() => presenter.onClickStartProcessing()}>
                                Start processing
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    },
);

export const PostProcessing = withPresenter<PostProcessingPresenter, OwnProps>(
    (props, component) => new PostProcessingPresenter(props.reportData.snippets, component.network.snippets),
    PostProcessingComponent,
);
